import script from "./MallTrackingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallTrackingModal.vue?vue&type=script&setup=true&lang=ts"

import "./MallTrackingModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__